module.exports = __webpack_public_path__ + "53610025d77a5d26a5cd130ed42f93ad.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-19.png
// module id = 1462
// module chunks = 0